import { LISTING_API_PREFIX } from 'src/common/constants';
import { EditorListing } from 'src/common/types/api/listings';
import bulkListingActionNotifications from '../bulkListingActionNotifications';
import callListingFetch, { ListingFetchResult } from '../callListingFetch';

const bulkPublishListings = async (listings: EditorListing[]): Promise<EditorListing[]> => {
  const promises = [];
  listings.forEach((listing) => {
    const url = `${LISTING_API_PREFIX}${listing.id}/publish`;
    promises.push(callListingFetch(listing.id, url, { method: 'POST' }));
  });

  const results: ListingFetchResult[] = await Promise.all(promises);
  bulkListingActionNotifications(results, listings, 'publish');
  return results.filter((r) => r.success).map((r) => r.data);
};

export default bulkPublishListings;
